<div class="create-skills">
    <div class="create-skills-wrap">
        <div class="create-skills-left">
            <div class="offset-4 col-lg-6 offset-2">
                <h2>Redes Sociales</h2>
            </div>
        </div>
    </div>

    <form [formGroup]="formRS" (ngSubmit)="actualizarRedesSociales()">
        <div class="row">
            <div class="offset-2 col-lg-8 offset-2">
                <div class="form-group">
                    <label><i class="icofont-linkedin"></i> Linkedin</label>
                    <input type="text" class="form-control" formControlName="linkedinUrl" [value]="perfilCandidato.linkedin">
                </div>

                <div class="form-group">
                    <label><i class="icofont-facebook"></i> Facebook</label>
                    <input type="text" class="form-control" formControlName="facebookUrl" [value]="perfilCandidato.facebook">
                </div>

                <div class="form-group">
                    <label><i class="icofont-twitter"></i> Twitter</label>
                    <input type="text" class="form-control" formControlName="twitterUrl" [value]="perfilCandidato.twitter">
                </div>
            </div>

            <div class="offset-2 col-lg-8 offset-2">
                <div class="form-group">
                    <div class="text-left">
                        <button type="submit" class="btn create-ac-btn">Actualizar</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
